import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabsbookingonpune() {



  const cardData = {


  keyword: "Sedan Cabs Booking in Pune",

  headingDescription: "Trustline Travels offers reliable sedan cab booking services in Pune for local travel, airport transfers, corporate transportation, business meetings, family trips, and outstation journeys. Our sedan cabs provide a perfect combination of comfort, affordability, and convenience for individuals, couples, and small groups. Choose from well-maintained sedan cars including Swift Dzire, Toyota Etios, Hyundai Aura, and other premium vehicles with professional chauffeurs. Whether you need a Pune local cab, Mumbai airport transfer, one-way taxi, round trip, corporate cab service, or outstation sedan booking, we ensure a smooth and comfortable travel experience. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, clean vehicles, flexible travel options, and 24/7 customer support, Trustline Travels is your trusted choice for sedan cab booking in Pune.",

  topPlaces: [
    {
      title: "Mumbai Airport",
      description: "Mumbai Airport is a major travel destination for Pune passengers requiring reliable airport transfers. Sedan cabs are a comfortable and economical choice for airport pickup and drop services."
    },
    {
      title: "Bandra Kurla Complex (BKC)",
      description: "Bandra Kurla Complex is Mumbai's leading business district, featuring corporate offices, financial institutions, luxury hotels, and convention centers. It is a preferred destination for Pune corporate travelers."
    },
    {
      title: "Andheri",
      description: "Andheri is one of Mumbai's busiest commercial hubs, known for IT companies, business offices, entertainment zones, hotels, and excellent airport connectivity. It is a popular route for Pune to Mumbai sedan cab services."
    },
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's largest technology hub, home to multinational companies, software firms, and corporate campuses. Sedan cabs are widely used for employee transportation and business travel."
    },
    {
      title: "Kharadi",
      description: "Kharadi is a major IT and commercial destination in Pune, featuring EON IT Park, corporate offices, hotels, and business centers. It is a preferred location for professional cab bookings."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a modern integrated township offering IT parks, corporate offices, shopping destinations, and residential communities. It is a popular pickup and drop location for corporate travelers."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, caves, viewpoints, and lush green valleys. Sedan cabs are suitable for comfortable weekend trips and sightseeing."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a beautiful hill station near Pune known for strawberry farms, scenic viewpoints, lakes, and waterfalls. It is a popular outstation destination for family and leisure travel."
    },
    {
      title: "Goa",
      description: "Goa is one of India's most popular holiday destinations, famous for beaches, nightlife, churches, adventure activities, and scenic locations. Sedan cabs are a convenient option for long-distance travel."
    },
    {
      title: "Alibaug",
      description: "Alibaug is a coastal getaway near Mumbai known for beaches, forts, and peaceful surroundings. It is a popular weekend destination for travelers booking comfortable sedan cabs from Pune."
    }
  ],





"services": [
  {
    "name": "Sedan Cabs in Pune",
    "description": "Book Sedan Cabs in Pune for comfortable local travel, airport transfers, corporate trips, and outstation journeys with clean AC vehicles, professional chauffeurs, affordable pricing, and reliable cab service."
  },
  {
    "name": "Best Cab Service in Pune",
    "description": "Choose the Best Cab Service in Pune offering well-maintained Sedan cars, experienced drivers, transparent fares, doorstep pickup, online booking, and 24x7 transportation support."
  },
  {
    "name": "Sedan Taxi Near Me in Pune",
    "description": "Find Sedan Taxi Near Me in Pune for quick and reliable travel with comfortable AC cars, professional drivers, instant booking, and affordable taxi fares."
  },
  {
    "name": "Sedan Cab Service Near Me in Pune",
    "description": "Book Sedan Cab Service Near Me in Pune for city rides, airport transfers, business travel, and outstation trips with safe and comfortable transportation."
  },
  {
    "name": "Sedan Cab Service for Outstations",
    "description": "Hire Sedan Cab Service for Outstations with experienced chauffeurs, clean AC vehicles, flexible packages, transparent pricing, and smooth long-distance travel."
  },
  {
    "name": "Toyota Etios Taxi in Pune",
    "description": "Book Toyota Etios Taxi in Pune for economical and comfortable travel with professional drivers, AC facilities, affordable rates, and reliable service."
  },
  {
    "name": "Toyota Etios Cab in Pune",
    "description": "Choose Toyota Etios Cab in Pune for local rides, airport pickup, corporate travel, and outstation journeys with comfortable seating and experienced chauffeurs."
  },
  {
    "name": "Taxi & Sedan Services Booking",
    "description": "Complete Taxi & Sedan Services Booking with premium vehicles, instant confirmation, flexible travel options, professional drivers, and hassle-free transportation."
  },
  {
    "name": "Sedan Taxi Service for Outstations",
    "description": "Book Sedan Taxi Service for Outstations with affordable fares, comfortable AC sedans, experienced chauffeurs, and reliable highway travel."
  },
  {
    "name": "Pune to Nashik Sedan Cab Service",
    "description": "Travel Pune to Nashik with Sedan Cab Service offering comfortable vehicles, professional drivers, fixed fares, and safe outstation transportation."
  },
  {
    "name": "Pune to Goa Cab Service",
    "description": "Book Pune to Goa Cab Service for long-distance travel with comfortable Sedan cars, experienced chauffeurs, affordable pricing, and smooth highway journeys."
  },
  {
    "name": "Pune to Mumbai Cab Services",
    "description": "Choose Pune to Mumbai Cab Services for reliable intercity travel with AC Sedan vehicles, professional drivers, doorstep pickup, and transparent pricing."
  },
  {
    "name": "Pune to Lonavala Sedan Cab",
    "description": "Book Pune to Lonavala Sedan Cab for weekend trips and sightseeing with comfortable AC cars, experienced drivers, and affordable travel packages."
  },
  {
    "name": "Outstation Sedan Cab Service",
    "description": "Choose Outstation Sedan Cab Service for family trips, business travel, and long-distance journeys with clean vehicles and professional chauffeur support."
  },
  {
    "name": "Sedan Cabs for Corporate Outstation",
    "description": "Book Sedan Cabs for Corporate Outstation travel with punctual service, comfortable vehicles, professional drivers, and reliable employee transportation solutions."
  },
  {
    "name": "Pune to Shirdi Sedan Cabs",
    "description": "Travel Pune to Shirdi with Sedan Cabs offering safe pilgrimage travel, comfortable seating, experienced drivers, and affordable fares."
  },
  {
    "name": "Pune to Aurangabad Sedan Taxi",
    "description": "Reserve Pune to Aurangabad Sedan Taxi for comfortable outstation travel with AC cars, professional chauffeurs, and transparent pricing."
  },
  {
    "name": "Sedan Cab Booking in Pune",
    "description": "Book Sedan Cab Booking in Pune for airport transfers, local rides, corporate travel, and outstation journeys with instant confirmation."
  },
  {
    "name": "Sedan Cab in Pune",
    "description": "Hire Sedan Cab in Pune for comfortable and affordable travel with clean AC vehicles, skilled drivers, and reliable cab service."
  },
  {
    "name": "Sedan Taxi Service Pune",
    "description": "Choose Sedan Taxi Service Pune for business trips, airport transfers, family travel, and outstation rides with professional chauffeur assistance."
  },
  {
    "name": "Sedan Cab Hire Pune",
    "description": "Book Sedan Cab Hire Pune for flexible travel plans with affordable rates, premium comfort, and well-maintained vehicles."
  },
  {
    "name": "Book Sedan Cab Pune",
    "description": "Book Sedan Cab Pune online with easy reservations, multiple vehicle options, professional drivers, and comfortable travel solutions."
  },
  {
    "name": "Cheap Sedan Cab Pune",
    "description": "Hire Cheap Sedan Cab Pune with budget-friendly fares, AC comfort, reliable drivers, and quality transportation services."
  },
  {
    "name": "Sedan Taxi Booking Pune",
    "description": "Complete Sedan Taxi Booking Pune for local and outstation travel with transparent pricing and instant booking facilities."
  },
  {
    "name": "AC Sedan Cab Pune",
    "description": "Travel with AC Sedan Cab Pune featuring clean interiors, comfortable seating, experienced chauffeurs, and smooth journeys."
  },
  {
    "name": "Pune Sedan Taxi Service",
    "description": "Choose Pune Sedan Taxi Service for reliable city transportation, airport transfers, corporate travel, and long-distance cab requirements."
  },
  {
    "name": "Sedan Cab for Outstation Pune",
    "description": "Book Sedan Cab for Outstation Pune with professional drivers, comfortable AC vehicles, fixed pricing, and safe highway travel."
  },
  {
    "name": "Sedan Cab Pune Airport Pickup",
    "description": "Reserve Sedan Cab Pune Airport Pickup for timely airport transfers with experienced chauffeurs, luggage assistance, and comfortable rides."
  },
  {
    "name": "Sedan Cab Pune to Mumbai",
    "description": "Book Sedan Cab Pune to Mumbai for convenient intercity travel with affordable fares, AC vehicles, and professional drivers."
  },
  {
    "name": "Online Sedan Cab Booking Pune",
    "description": "Complete Online Sedan Cab Booking Pune with instant confirmation, secure reservations, multiple vehicle choices, and 24x7 availability."
  },
  {
    "name": "Best Sedan Cab Service Pune",
    "description": "Choose Best Sedan Cab Service Pune for premium comfort, reliable chauffeurs, affordable pricing, and hassle-free local and outstation travel."
  }
],

"tableData": [
  ["Sedan Cabs in Pune", "Best Cab Service in Pune"],
  ["Sedan Taxi Near Me in Pune", "Sedan Cab Service Near Me in Pune"],
  ["Sedan Cab Service for Outstations", "Toyota Etios Taxi in Pune"],
  ["Toyota Etios Cab in Pune", "Taxi & Sedan Services Booking"],
  ["Sedan Taxi Service for Outstations", "Pune to Nashik Sedan Cab Service"],
  ["Pune to Goa Cab Service", "Pune to Mumbai Cab Services"],
  ["Pune to Lonavala Sedan Cab", "Outstation Sedan Cab Service"],
  ["Sedan Cabs for Corporate Outstation", "Pune to Shirdi Sedan Cabs"],
  ["Pune to Aurangabad Sedan Taxi", "Sedan Cab Booking in Pune"],
  ["Sedan Cab in Pune", "Sedan Taxi Service Pune"],
  ["Sedan Cab Hire Pune", "Book Sedan Cab Pune"],
  ["Cheap Sedan Cab Pune", "Sedan Taxi Booking Pune"],
  ["AC Sedan Cab Pune", "Pune Sedan Taxi Service"],
  ["Sedan Cab for Outstation Pune", "Sedan Cab Pune Airport Pickup"],
  ["Sedan Cab Pune to Mumbai", "Online Sedan Cab Booking Pune"],
  ["Best Sedan Cab Service Pune", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Sedan Cabs Booking in Pune",
    WhyChoosedescription: "Trustline Cab provides comfortable sedan cab booking services in Pune with professional chauffeurs, clean vehicles, and smooth travel solutions for local and outstation journeys."
  },
  {
    WhyChooseheading: "Comfortable Sedan Cars for Every Trip",
    WhyChoosedescription: "Choose spacious and well-maintained sedan cars like Swift Dzire, Aura, Etios, and similar vehicles for a comfortable travel experience."
  },
  {
    WhyChooseheading: "Pickup Available Across Pune",
    WhyChoosedescription: "Get convenient sedan cab pickup from Pune Airport, railway station, Hinjewadi, Wakad, Baner, Kharadi, Viman Nagar, Pimpri Chinchwad, and other locations."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our trained drivers ensure safe, punctual, and hassle-free journeys with excellent knowledge of Pune city and outstation routes."
  },
  {
    WhyChooseheading: "Affordable Sedan Rental Services",
    WhyChoosedescription: "Book sedan cabs for local rides, airport transfers, one-way trips, round trips, and outstation travel with transparent pricing."
  },
  {
    WhyChooseheading: "Ideal for Business & Personal Travel",
    WhyChoosedescription: "Sedan cabs are perfect for corporate meetings, office travel, airport transfers, family trips, and comfortable long-distance journeys."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Fleet",
    WhyChoosedescription: "All sedan vehicles are regularly serviced and maintained to provide a safe, hygienic, and comfortable ride."
  },
  {
    WhyChooseheading: "24/7 Sedan Cab Booking Support",
    WhyChoosedescription: "Reserve your sedan cab in Pune anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Sedan Cabs Booking in Pune?",
    answer: "Yes, Trustline Travels offers sedan cab booking services in Pune for local travel, airport transfers, corporate trips, and outstation journeys."
  },
  {
    question: "Which sedan cars are available for booking in Pune?",
    answer: "We provide comfortable sedan cars including Swift Dzire, Aura, Etios, and other suitable vehicles based on availability and travel requirements."
  },
  {
    question: "Can I book a sedan cab with a driver in Pune?",
    answer: "Yes, chauffeur-driven sedan cab services are available for safe and comfortable travel across Pune and nearby destinations."
  },
  {
    question: "Where can I get sedan cab pickup in Pune?",
    answer: "Pickup is available from Pune Airport, railway station, hotels, offices, residential areas, and major locations across Pune."
  },
  {
    question: "Can I book a sedan cab for outstation trips from Pune?",
    answer: "Yes, sedan cabs are available for destinations like Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, and other outstation routes."
  },
  {
    question: "Is sedan cab booking available 24 hours in Pune?",
    answer: "Yes, sedan cab booking services are available 24/7 according to your preferred travel schedule."
  },
  {
    question: "Are sedan cabs suitable for airport transfers?",
    answer: "Yes, sedan cabs are a comfortable option for Pune Airport pickup, drop, and business airport transfers."
  },
  {
    question: "What rental options are available for sedan cabs?",
    answer: "You can book sedan cabs for hourly rental, daily packages, one-way trips, round trips, and customized travel plans."
  },
  {
    question: "Can I book sedan cabs for corporate travel?",
    answer: "Yes, sedan cab services are suitable for employee transportation, business meetings, client visits, and executive travel."
  },
  {
    question: "How can I book Sedan Cabs in Pune with Trustline Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Kulkarni",
    feedback: "I booked a sedan cab in Pune for an airport transfer and the service was excellent. The car was clean, the driver was punctual, and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Patil",
    feedback: "Trustline Travels provided a smooth sedan cab booking experience. The driver was professional, the vehicle was well-maintained, and the entire trip was managed perfectly.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cabs Booking in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/sedan-cabs-booking-in-pune.webp",
  "description":
    "Book Sedan Cabs Booking in Pune with Trustline Travels for safe, comfortable, and affordable taxi services. We provide Sedan cabs including Swift Dzire, Hyundai Aura, Honda Amaze, and Toyota Etios for local travel, airport transfers, corporate travel, outstation trips, one-way, and round-trip journeys with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/sedan-cabs-booking-in-pune"
  }
};




  return (
    <div>


<Helmet>
  <title>Sedan Cabs Booking in Pune | Sedan Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Sedan Cabs Booking in Pune with Trustline Travels for affordable sedan taxi services. Hire Swift Dzire, Hyundai Aura, Honda Amaze, and Toyota Etios for local travel, airport transfers, corporate travel, outstation trips, Pune to Nashik, and one-way or round-trip journeys with 24x7 availability."
  />

  <meta
    name="keywords"
    content="sedan cabs in Pune, best cab service in pune, Sedan taxi near me in Pune, Sedan cab service near me in Pune, Sedan cab service for Outstations, Toyota etios taxi in Pune, Toyota etios cab in Pune, Taxi & Sedan services Booking, Sedan Taxi Service for Outstations, pune to nashik sedan cab service, Sedan Cabs Booking in Pune, Pune Sedan Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/10.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabsbookingonpune;